
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import NavLinks from "./NavLinks";

interface MobileMenuProps {
  isOpen: boolean;
  user: any;
  canViewDocs: boolean;
  isAdmin: boolean;
  signOut: () => void;
  onClose: () => void;
}

const MobileMenu = ({ 
  isOpen, 
  user, 
  canViewDocs, 
  isAdmin, 
  signOut, 
  onClose 
}: MobileMenuProps) => {
  if (!isOpen) return null;

  return (
    <div className="md:hidden border-t p-4 bg-white dark:bg-fraudeye-primary animate-slide-up">
      <NavLinks 
        canViewDocs={canViewDocs} 
        isAdmin={isAdmin} 
        isMobile={true}
        onItemClick={onClose}
      />
      
      <div className="flex flex-col gap-2 pt-2">
        {user ? (
          <Button 
            variant="outline" 
            onClick={() => {
              signOut();
              onClose();
            }}
            className="w-full justify-start"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Log out
          </Button>
        ) : (
          <>
            <Button 
              variant="outline" 
              size="sm" 
              className="w-full"
              onClick={onClose}
              asChild
            >
              <Link to="/login">Login</Link>
            </Button>
            <Button 
              size="sm" 
              className="w-full bg-fraudeye-accent hover:bg-fraudeye-highlight"
              onClick={onClose}
              asChild
            >
              <Link to="/register">Get Started</Link>
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileMenu;
